import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Tooltip, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import useInstallationStats from 'src/Hooks/use-installation-stats'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  greetingMessageNumber: {
    color: theme.palette.primary.main,
  },
}))

/**
 * Component to display the number of installations on the installer dashboard
 */
const InstallationCounter: React.FC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { installationsCount, installationsNoAccessCount, allInstallationsCount } = useInstallationStats()
  const installationCounterTooltip = t('dashboard.installation-counter.tooltip', {
    installations: installationsCount,
    installationsNoAccess: installationsNoAccessCount,
  })

  return (
    <Tooltip title={installationCounterTooltip}>
      <Box className={classes.container} data-qa={'greeting-installation-counter'}>
        <Typography variant="h3">
          <Box component="span" className={classes.greetingMessageNumber}>
            {allInstallationsCount}
          </Box>
          {t('dashboard.installation-counter.installed-systems')}
        </Typography>
      </Box>
    </Tooltip>
  )
}

export default InstallationCounter
